var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgGrowthIcon = function SvgGrowthIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#growth-icon_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50a24.966 24.966 0 01-13.871-4.221 24.995 24.995 0 01-9.193-11.22 25.018 25.018 0 015.42-27.237A24.962 24.962 0 0134.57 1.9a24.985 24.985 0 0111.21 9.2A25.014 25.014 0 0150 24.98a25.06 25.06 0 01-7.332 17.683A25.021 25.021 0 0125 50zm0-45.914a20.887 20.887 0 00-11.603 3.532 20.911 20.911 0 00-7.689 9.387 20.93 20.93 0 004.534 22.784 20.893 20.893 0 0022.765 4.537 20.901 20.901 0 009.38-7.694 20.926 20.926 0 003.53-11.612A20.921 20.921 0 0039.8 10.209a20.888 20.888 0 00-14.8-6.123z",
    fill: "#33BB40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M37.558 13.735a4.671 4.671 0 01-4.627 4.67h-12.13a4.03 4.03 0 00-4.044 4.007.335.335 0 01-.311.312.308.308 0 01-.311-.312v-4.319a4.67 4.67 0 014.665-4.669h16.486a.275.275 0 01.272.311z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.826 21.596H20.8a4.663 4.663 0 00-4.666 4.63v4.358a.311.311 0 10.622 0 4.072 4.072 0 014.044-4.047h8.71a4.664 4.664 0 004.665-4.67.432.432 0 00-.35-.271z",
    fill: "#33BB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.365 29.767H20.8a4.664 4.664 0 00-4.665 4.669v4.319a.309.309 0 00.43.289.306.306 0 00.192-.289 4.072 4.072 0 014.043-4.047h5.21a4.664 4.664 0 004.666-4.669.3.3 0 00-.311-.272z",
    fill: "#229F43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "growth-icon_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
};

export default SvgGrowthIcon;